import { useEffect, useState } from 'react';
import BlogService from '../../services/BlogService';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';

const BlogListPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    BlogService.fetchAll()
      .then((r) => {
        setBlogs(r.data.data || []);
        setLoading(false);
      })
      .catch(() => {
        setError('Greška pri učitavanju blogova.');
        setLoading(false);
      });
  }, []);

  return (
    <div className='container mx-auto py-8'>
      <SEO
        title='Blog – Rentasvet'
        description='Pratite Rentasvet blog – praktični saveti za rentiranje i iznajmljivanje, novosti sa platforme, vodiči za oglašivače i zakupce u Srbiji.'
        keywords='blog, Rentasvet blog, saveti za rentiranje, iznajmljivanje saveti, oglašavanje, vodiči, vesti, rentiranje Srbija'
        url='/blog'
        lang='sr'
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'Blog – Rentasvet',
          url: 'https://rentasvet.rs/blog',
          description: 'Saveti i vodiči za rentiranje i iznajmljivanje u Srbiji.',
          publisher: { '@type': 'Organization', name: 'Rentasvet', url: 'https://rentasvet.rs' },
        }}
      />
      <h1 className='mb-8 text-center text-4xl font-extrabold'>Blog</h1>
      {loading && <div>Učitavanje...</div>}
      {error && <div className='text-red-500'>{error}</div>}
      {!loading && !error && (
        <div className='grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3'>
          {blogs.length === 0 ? (
            <div className='col-span-2 p-4'>Nema blog postova.</div>
          ) : (
            blogs.map((blog) => (
              <Link
                key={blog._id}
                to={`/blog/${blog.slug}`}
                className='group block h-full overflow-hidden rounded-lg border bg-white shadow-lg transition hover:shadow-2xl'
              >
                {blog.images && blog.images.length > 0 && (
                  <img
                    src={blog.images[0].startsWith('http') ? blog.images[0] : import.meta.env.VITE_IMAGE_URL + blog.images[0]}
                    alt={blog.title}
                    className='h-52 w-full object-cover transition-transform duration-200 group-hover:scale-105'
                  />
                )}
                <div className='flex flex-col gap-2 p-6'>
                  <h2 className='text-xl font-bold'>{blog.title}</h2>
                  {/*   <div className='mb-2 text-xs text-gray-400'>{new Date(blog.date).toLocaleDateString()}</div> */}
                  <div className='text-sm text-gray-700'>{blog.excerpt || blog.content?.slice(0, 100) + '...'}</div>
                  <span className='mt-3 text-xs font-semibold text-blue-600 group-hover:underline'>Pročitaj više</span>
                </div>
              </Link>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default BlogListPage;
